export enum OrderGroup {
  active = 'active',
  completed = 'completed',
}
